import { DialogContent } from '@material-ui/core';

// @ts-expect-error - no TypeScript definitions yet
import { CUSTOM_BUTTON_COLOR } from 'src/components/CustomButton';
// @ts-expect-error - no TypeScript definitions yet
import { CustomDialog } from 'src/components/CustomDialog';
import { pluralize } from 'src/lib/format';
import type { CallbackN } from 'src/lib/types';

import styles from './DeleteCommentPopup.module.scss';

interface DeleteCommentPopupProps {
  open: boolean;
  replyCount: number;
  onClose: CallbackN<[boolean]>;
}

export const DeleteCommentPopup = ({ open, replyCount, onClose }: DeleteCommentPopupProps) => (
  <CustomDialog
    className={styles.root}
    open={open}
    title="Delete this comment?"
    cancelLabel="Cancel"
    submitLabel="Delete"
    submitProps={{ color: CUSTOM_BUTTON_COLOR.danger }}
    onSubmit={() => onClose(true)}
    onCancel={() => onClose(false)}
    onClose={() => onClose(false)}
  >
    <DialogContent className={styles.content}>
      {replyCount > 0
        ? `This removes your comment and its ${replyCount} ${pluralize(replyCount, 'reply', 'replies')} for everyone. It can’t be undone.`
        : 'This removes your comment for everyone. It can’t be undone.'}
    </DialogContent>
  </CustomDialog>
);
